import { render, staticRenderFns } from "./StaticSearch.vue?vue&type=template&id=000cb57d&"
import script from "./StaticSearch.vue?vue&type=script&lang=js&"
export * from "./StaticSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports